import { useIsDesktop } from '@/_hooks/useBreakpoint';

import FooterDesktop from './footer.desktop';
import FooterMobile from './footer.mobile';
import { IModifierQuantityObj, ISavedBranch } from '@/_store/types';
import {
    IProductVariant,
    ISavedModifier,
} from '@/_types';
import { IProduct } from '@/entities/product/model/types';

export interface IFooterProps {
    branch: ISavedBranch | null;
    shipperId: string,
    data: IProduct | undefined;
    activeVariant: IProductVariant | null;
    totalDiscount: number;
    price: number;
    modifiersPrice: number;
    quantity: number;
    productInCart: any;
    orderModifiers: ISavedModifier[];
    modifiersQuantity: IModifierQuantityObj[];
    compulsories: ISavedModifier[];
    setStartTracking: (value: boolean) => void;
    onIncrease: () => void;
    onDecrease: () => void;
    onRedirectToCart?: () => void;
    backToBrand: () => void;
    expectedModifier: string[];
}

export default function Footer(props: IFooterProps) {
    const isDesktop = useIsDesktop();
    if (isDesktop) {
        return <FooterDesktop {...props} />
    }
    return <FooterMobile {...props} />

}
